export default __webpack_public_path__ + "static/create-experiment-light-mode-cfb7ca3289ed5d589a54eb49ae9c3489.png";